<template>
  <div class="side-menu">
    <div class="search-main">
      <div class="title-wrapper">
        <div class="font-topic-bold" v-tip>{{ project.name }}</div>
        <span @click="gotoFrontend()" class="icon-back">
          <svg-icon icon-class="back"></svg-icon>
        </span>
      </div>
      <div class="search-query">
        <el-input
          v-model="searchText"
          size="small"
          prefix-icon="el-icon-search"
          placeholder="请输入"
          :class="themeStyle.search"
          clearable
        ></el-input>
      </div>
      <div class="scroll-wrap no-bar">
        <base-side-menu :menuList="filterMenu" :default-menu="defaultMenu"></base-side-menu>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSideMenu from "@/components/BaseComponents/SideMenu"
import { themeStyleMap } from "@/views/Front/Sheet/Layout/static"

export default {
  name: "side-menu",
  props: {
    project: {
      type: Object,
      default: () => ({
        template: true,
        name: "",
        id: ""
      })
    }
  },
  components: {
    BaseSideMenu
  },
  data() {
    return {
      searchText: "",
      themeStyleMap,
      menuList: [
        {
          label: "项目",
          value: "admin-project",
          icon: "admin-project",
          hideWhenTemplate: true,
          children: [
            {
              label: "项目信息",
              value: "admin-project-info",
              icon: "el-icon-s-help"
            },
            {
              label: "项目操作",
              value: "admin-project-operation",
              icon: "el-icon-s-help"
            },
            {
              label: "群机器人",
              value: "admin-project-robot",
              icon: "el-icon-s-help"
            }
          ]
        },
        {
          label: "任务",
          value: "admin-project-task",
          icon: "admin-project-task",
          children: [
            {
              label: "任务分组",
              value: "admin-project-task-group",
              icon: "el-icon-s-help"
            },
            {
              label:"任务配置",
              value: "admin-project-task-setting",
              icon: "el-icon-s-help"
            },
            {
              label: "任务类型",
              value: "admin-project-task-template",
              icon: "el-icon-s-help"
            },
            {
              label: "任务审批",
              value: "admin-project-task-approval",
              icon: "el-icon-s-help"
            },
            {
              label: "任务提醒",
              value: "admin-project-task-remind",
              icon: "el-icon-s-help"
            },
            {
              label: "任务权限",
              value: "admin-project-task-authority",
              icon: "el-icon-s-help"
            }
          ]
        },
        {
          label: "角色成员",
          value: "admin-project-user",
          icon: "admin-project-user",
          children: [
            {
              label: "项目角色",
              value: "admin-project-user-role",
              icon: "el-icon-s-help"
            },
            {
              label: "项目成员",
              value: "admin-project-user-member",
              icon: "el-icon-s-help",
              hideWhenTemplate: true
            }
          ]
        }
      ]
    }
  },
  computed: {
    filterMenu() {
      // 首先根据当前是否是项目模板,过滤一些模板不可见的分组
      let list = this.filterTemplate(this.menuList)
      if (!this.searchText) return list
      return list.reduce((acc, cur) => {
        if (!cur.children) {
          if (cur.label.includes(this.searchText)) acc.push(cur)
        } else {
          let match = cur.children.filter(i => i.label.includes(this.searchText))
          acc = acc.concat(match)
        }
        return acc
      }, [])
    },
    theme() {
      return this.$store.getters.theme
    },
    themeStyle() {
      return this.themeStyleMap[this.theme]
    },
    defaultMenu() {
      if (!this.searchText) return []
      return this.filterMenu?.map(subMenuList => subMenuList.value)
    }
  },
  methods: {
    filterTemplate(menuList) {
      if (!this.project.template) return menuList
      if (!menuList) return menuList
      return menuList.filter(menu => {
        if (menu.hideWhenTemplate) return false
        menu.children = this.filterTemplate(menu.children)
        return true
      })
    },
    gotoFrontend() {
      this.$router.push({
        name: "project-task-list",
        params: {
          projectId: this.project.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  .search-main {
    padding: 12px 16px;
    .title-wrapper {
      display: flex;
      align-items: center;
      position: absolute;
      top: 20px;
      right: 20px;
      width: 205px;
      .icon-back {
        font-size: 20px;
        margin-left: auto;
        cursor: pointer;
      }
    }
    .search-query {
      position: absolute;
      top: 60px;
      right: 20px;
      width: 205px;
    }
    .scroll-wrap {
      position: absolute;
      left: 0;
      right: 5px;
      top: 95px;
      bottom: 0;
      overflow: scroll;
    }
  }
  .search {
    ::v-deep {
      .el-input__inner {
        background-color: #c0c4cc;
        opacity: 0.3;
      }
    }
  }
}
</style>
